var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBinance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fc2a02"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14960 -4001)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "url(#a)",
    "data-name": "Ellipse 22-2",
    transform: "translate(14960 4001)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15150.252 4229.828 65.555-65.528 65.582 65.582 38.123-38.15L15215.807 4088l-103.7 103.7Z",
    "data-name": "Path 323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15047 4256.781 38.123-38.15 38.15 38.15-38.15 38.128Z",
    "data-name": "Path 324"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15150.252 4283.709 65.556 65.556 65.582-65.583 38.15 38.1-103.706 103.727-103.734-103.652Z",
    "data-name": "Path 325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15308.263 4256.781 38.123-38.15 38.15 38.123-38.15 38.177Z",
    "data-name": "Path 326"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15254.491 4256.755-38.683-38.71-28.606 28.606-3.306 3.279-6.771 6.771 38.683 38.656 38.683-38.576Z",
    "data-name": "Path 327"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/binance.4cd9b9caddbfe0f9f40dc5261408c29d.svg";
export { ForwardRef as ReactComponent };